import Icon, { BaseIconProps } from './Icon'
function NotificationIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 109 115"
        {...props}
      >
        <path
          fill="#C9C9C9"
          fillOpacity={0.5}
          d="M37.53 96.38h29.89v3.56c0 8.25-6.69 14.95-14.95 14.95s-14.95-6.69-14.95-14.95c.01-.01.01-3.56.01-3.56"
        />
        <path
          fillOpacity={0.1}
          stroke="#E4E4E4"
          d="M37.53 96.38h29.89v3.56c0 8.25-6.69 14.95-14.95 14.95s-14.95-6.69-14.95-14.95c.01-.01.01-3.56.01-3.56z"
        />
        <path
          fill="#C9C9C9"
          fillOpacity={0.5}
          fillRule="evenodd"
          d="m64.15 14.35-.01-3.38C64.12 5.34 59.55.79 53.92.79 48.28.79 43.7 5.36 43.7 11v3.27c-15.3 4.37-26.51 18.47-26.51 35.18v20.54L4.54 82.58C2.19 84.92.74 88.03.47 91.34l-.42 5.03h108.19l-.05-4.28a14 14 0 0 0-4.64-10.25L90.36 69.99V49.45c0-16.6-11.06-30.62-26.21-35.1"
          clipRule="evenodd"
        />
        <path
          fillOpacity={0.5}
          d="M17.13 66.96H90.2v3.8H17.13z"
          opacity={0.2}
        />
        <path
          fillOpacity={0.5}
          d="M37.53 96.38h29.89v3.8H37.53z"
          opacity={0.3}
        />
        <path fillOpacity={0.5} d="M43.65 10.44h20.5v4h-20.5z" opacity={0.2} />
      </svg>
    </Icon>
  )
}
export default NotificationIcon
